import { PAGE_SIZE_OPTIONS } from './pageSizeOptions';

interface DownloadLogPaginationProps {
  page: number;
  size: number;
  total: number;
  onPageChange: (page: number) => void;
  onSizeChange: (size: number) => void;
}

/** Hand-rolled Previous/Next pager, matching the pattern used in Marketplace.tsx, plus a page-size selector. */
export const DownloadLogPagination = ({ page, size, total, onPageChange, onSizeChange }: DownloadLogPaginationProps) => {
  const totalPages = Math.max(1, Math.ceil(total / size));

  return (
    <div className="my-4 flex items-center justify-center gap-4">
      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <button
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page === 1}
            className="px-4 py-2 border rounded-lg disabled:opacity-50"
          >
            Previous
          </button>
          <span className="px-4 py-2 text-sm text-[#555]">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page === totalPages}
            className="px-4 py-2 border rounded-lg disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}

      <label className="flex items-center gap-2 text-sm text-[#555]">
        Rows per page
        <select
          value={size}
          onChange={e => onSizeChange(Number(e.target.value))}
          className="rounded-md border border-[#eaeaea] px-2 py-1"
        >
          {PAGE_SIZE_OPTIONS.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </label>
    </div>
  );
};
